import { Card, CardActionArea, CardContent, CardHeader, Grid, Typography } from "@mui/material"
import { LoadingIcon } from "components/Common/LoadingIcon"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import simulatorApplicationService from "services/simulatorApplicationService"
import {
  setCurrentSimulatorApplication,
  setSimulatorApplications,
} from "slices/simulatorApplicationSlice"
import type { ISimulatorApplication } from "types/simulatorApplicationTypes"
import { SimulatorApplicationCardMenu } from "./SimulatorApplicationCardMenu"

export function SimulatorApplicationList() {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const simulatorApplications = useAppSelector(
    (state) => state.simulatorapplication.simulatorApplications,
  )

  useEffect(() => {
    if (simulatorApplications.length === 0) {
      setIsLoading(true)
    }

    simulatorApplicationService
      .getSimulatorApplications()
      .then((apps) => {
        dispatch(setSimulatorApplications(apps))
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [dispatch, simulatorApplications.length])

  const handleClickSimulatorApplication = (app: ISimulatorApplication) => {
    dispatch(setCurrentSimulatorApplication(app))
    navigate(app.id)
  }

  return (
    <>
      {isLoading ? (
        <LoadingIcon />
      ) : (
        <Grid container spacing={2}>
          {simulatorApplications.map((app) => (
            <Grid key={app.id} item lg={4} md={6} xs={12}>
              <Card>
                <CardHeader
                  action={<SimulatorApplicationCardMenu app={app} />}
                  title={app.id}
                  titleTypographyProps={{ variant: "body2" }}
                ></CardHeader>
                <CardActionArea onClick={() => handleClickSimulatorApplication(app)}>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {app.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      This is app
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  )
}
